import { render, staticRenderFns } from "./FPTemp2.vue?vue&type=template&id=c479d8d4&scoped=true&"
import script from "./FPTemp2.vue?vue&type=script&lang=js&"
export * from "./FPTemp2.vue?vue&type=script&lang=js&"
import style0 from "./FPTemp2.vue?vue&type=style&index=0&id=c479d8d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c479d8d4",
  null
  
)

export default component.exports